const GET_PRODUCTO_URL = "productos/producto/"
const HISTORICO_AJUSTE = "sucursal/ajustes"
const HISTORICO_DEVOLUCION_CLIENTE = "post-venta/dcto-devolucion/historico"
const HISTORICO_DEVOLUCION_PROVEEDOR = "sucursal/historico-producto/devoluciones"
const URL_ETIQUETAS_INDIVIDUALES = "productos/etiquetas";

export {
    GET_PRODUCTO_URL,
    HISTORICO_AJUSTE,
    HISTORICO_DEVOLUCION_CLIENTE,
    HISTORICO_DEVOLUCION_PROVEEDOR,
    URL_ETIQUETAS_INDIVIDUALES
}
